import { render } from "./AttentionOctagonIcon16.vue.js?vue&type=template&id=ebab5098!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./AttentionOctagonIcon16.vue?vue&type=template&id=ebab5098"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__